import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://api.dilanaslan.com/api";

// Tüm randevuları çek
export const fetchAppointments = createAsyncThunk(
  "appointments/fetchAppointments",
  async () => {
    const res = await axios.get(`${BASE_URL}/appointments`);
    return res.data;
  }
);

// Bekleyen randevuları çek (admin için)
export const fetchPendingAppointments = createAsyncThunk(
  "appointments/fetchPendingAppointments",
  async () => {
    const res = await axios.get(`${BASE_URL}/appointments/pending`);
    return res.data;
  }
);

// Yeni randevu oluştur (sadece tarih ile)
export const createAppointment = createAsyncThunk(
  "appointments/createAppointment",
  async (newAppointment, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${BASE_URL}/appointments`, newAppointment);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Randevu oluşturulamadı"
      );
    }
  }
);

// Admin randevuya saat atar
export const setAppointmentTime = createAsyncThunk(
  "appointments/setAppointmentTime",
  async ({ id, time }, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`${BASE_URL}/appointments/${id}/set-time`, {
        time,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Saat belirlenemedi"
      );
    }
  }
);

// Randevu sil
export const deleteAppointment = createAsyncThunk(
  "appointments/deleteAppointment",
  async (id) => {
    await axios.delete(`${BASE_URL}/appointments/${id}`);
    return id;
  }
);

// Randevu durumu güncelle
export const updateAppointmentStatus = createAsyncThunk(
  "appointments/updateAppointmentStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`${BASE_URL}/appointments/${id}/status`, {
        status,
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Durum güncellenemedi"
      );
    }
  }
);

const appointmentsSlice = createSlice({
  name: "appointments",
  initialState: {
    items: [],
    pendingItems: [],
    loading: false,
    error: null,
    settingTime: false,
    setTimeError: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.setTimeError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchAppointments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAppointments.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchAppointments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch Pending
      .addCase(fetchPendingAppointments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPendingAppointments.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingItems = action.payload;
      })
      .addCase(fetchPendingAppointments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Create
      .addCase(createAppointment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAppointment.fulfilled, (state, action) => {
        state.loading = false;
        state.items.push(action.payload.appointment);
      })
      .addCase(createAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Set Time
      .addCase(setAppointmentTime.pending, (state) => {
        state.settingTime = true;
        state.setTimeError = null;
      })
      .addCase(setAppointmentTime.fulfilled, (state, action) => {
        state.settingTime = false;
        const updatedApp = action.payload.appointment;
        // Tüm listeyi güncelle
        state.items = state.items.map((app) =>
          app._id === updatedApp._id ? updatedApp : app
        );
        // Pending listesinden çıkar
        state.pendingItems = state.pendingItems.filter(
          (app) => app._id !== updatedApp._id
        );
      })
      .addCase(setAppointmentTime.rejected, (state, action) => {
        state.settingTime = false;
        state.setTimeError = action.payload;
      })

      // Update Status
      .addCase(updateAppointmentStatus.fulfilled, (state, action) => {
        const updatedApp = action.payload.appointment;
        state.items = state.items.map((app) =>
          app._id === updatedApp._id ? updatedApp : app
        );
      })

      // Delete
      .addCase(deleteAppointment.fulfilled, (state, action) => {
        state.items = state.items.filter((a) => a._id !== action.payload);
        state.pendingItems = state.pendingItems.filter(
          (a) => a._id !== action.payload
        );
      });
  },
});

export const { clearError } = appointmentsSlice.actions;
export default appointmentsSlice.reducer;
